import React from 'react';
import { Box, Typography } from '@mui/material';

import Switch from '../../../../common/Switch';
import { AgenticPersonality } from '../../../../store/modules/merchant/types';
import { AgentViewSelect } from './AgentViewSelect';
import { DateRangeSelector, DateRangeValue } from './DateRangeSelector';

const switchCheckedSx = {
  '& .gc-switch.root.is-checked': {
    backgroundColor: 'brand.main',
    borderColor: 'brand.main',
  },
  '& .gc-switch.root.is-checked .gc-switch.checked-copy': {
    color: 'common.black',
  },
};

type AgentFilterToolbarProps = {
  personalities: AgenticPersonality[];
  selectedPersonalityId: string;
  onPersonalityChange: (next: string) => void;
  excludeTestSessions: boolean;
  onExcludeTestSessionsChange: (next: boolean) => void;
  excludeTestSessionsLabel?: string;
  showDateRange?: boolean;
  dateRange?: DateRangeValue;
  onDateRangeChange?: (next: DateRangeValue) => void;
  disabled?: boolean;
};

export const AgentFilterToolbar = ({
  personalities,
  selectedPersonalityId,
  onPersonalityChange,
  excludeTestSessions,
  onExcludeTestSessionsChange,
  excludeTestSessionsLabel = 'Exclude Skipify test users from metrics',
  showDateRange = true,
  dateRange,
  onDateRangeChange,
  disabled,
}: AgentFilterToolbarProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 2,
      flexWrap: 'wrap',
      mb: 4,
      pt: 1.5,
      pb: 2,
    }}
  >
    <AgentViewSelect
      value={selectedPersonalityId}
      personalities={personalities}
      onChange={onPersonalityChange}
      disabled={disabled}
    />
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        flexWrap: 'wrap',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          ...switchCheckedSx,
        }}
        data-testid="ella-exclude-test-users-toggle"
      >
        <Switch
          isChecked={excludeTestSessions}
          onToggle={onExcludeTestSessionsChange}
          isDisabled={disabled}
          aria-label={excludeTestSessionsLabel}
          data-testid="ella-exclude-test-users-switch"
        />
        <Typography variant="small">{excludeTestSessionsLabel}</Typography>
      </Box>
      {showDateRange && dateRange && onDateRangeChange ? (
        <DateRangeSelector value={dateRange} onChange={onDateRangeChange} />
      ) : null}
    </Box>
  </Box>
);
